import { render, staticRenderFns } from "./order_page.vue?vue&type=template&id=07aabd10&scoped=true"
import script from "./order_page.vue?vue&type=script&lang=js"
export * from "./order_page.vue?vue&type=script&lang=js"
import style0 from "./order_page.vue?vue&type=style&index=0&id=07aabd10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aabd10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07aabd10')) {
      api.createRecord('07aabd10', component.options)
    } else {
      api.reload('07aabd10', component.options)
    }
    module.hot.accept("./order_page.vue?vue&type=template&id=07aabd10&scoped=true", function () {
      api.rerender('07aabd10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/logs/order_page.vue"
export default component.exports